module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "events"
  }, [(_vm.loading) ? _c('div', {
    staticClass: "loading"
  }, [_c('sk-progress-circular', {
    attrs: {
      "indeterminate": "",
      "size": "100",
      "width": 2,
      "primary": ""
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading),
      expression: "!loading"
    }]
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.events.length > 0),
      expression: "events.length > 0"
    }]
  }, _vm._l((_vm.events), function(event, index) {
    return _c('div', [_c('sk-exclusive-list', {
      attrs: {
        "event": "",
        "item": event,
        "movie": event.movie
      }
    })], 1)
  })), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.events.length == 0),
      expression: "events.length == 0"
    }]
  }, [_c('p', [_vm._v("There are no events at Ster-Kinekor at the moment.")]), _vm._v(" "), _c('p', [_vm._v("Please check again later or subscribe to our newsletter to keep up to date with what's on!")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-29d73c88","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/exclusive-to-sk/events/events.vue
// module id = 774
// module chunks = 0